<div class="min-h-[80vh] w-full">
  <div class="w-full bg-[#001847] h-[370px] relative" id="mask-image">
    <div class="container">
      <div class="w-full text-center relative  float-end mt-5 h-[360px]">
        <h1 class="text-white fw-medium fs-3 m-0 pb-2 mb-1   mt-5">ایران هتل
        </h1>
        <h2 class="text-white fs-1.6">گارانتی بهترین نرخ </h2>

      </div>

    </div>
  </div>
  <div class="container">
    <div class="w-full  mt-10">
      <nav>
        <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
          <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
            *ngFor="let bread of listBreadcrumb; let last = last; let index = index;let first = first">
            <ng-container *ngIf="!last">
              <a [href]="first ? '/' : bread['@id']">
                {{ bread.name }}
              </a>
            </ng-container>
            <ng-container *ngIf="last">
              <span class=""> {{ bread.name }} </span>
            </ng-container>

          </li>
        </ol>
      </nav>
    </div>
    <div class="w-full  mt-10">
      <h4 class="font-bold mt-5 title-content">
        گارانتی بهترین قیمت برای هتل به چه معناست؟
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        شبکه ایران هتل این ضمانت نامه را برای آسودگی خاطر هرچه بیشتر میهمانان از سطح قیمت ها در سایت ایران هتل ارائه می
        کند. در
        این ضمانت نامه، ایران هتل تضمین می کند، هتلی که برچسب بهترین نرخ (گارانتی بهترین قیمت ) را دارد، با پایین ترین
        قیمت نسبت
        به سایر وب سایت های اینترنتی فروش هتل در سراسر کشور عرضه شوند. اگر این وب سایت برای هتل مورد نظر ما که برچسب
        گارانتی نرخ
        را دارد با شرایط یکسان، قیمتی پایین تر از ایران هتل ارائه نمود، میهمان می تواند درخواست استفاده از تضمین گارانتی
        قیمت را
        ارائه دهد. ایران هتل نیز برای تشکر و پاسخ به اعتماد مشتری ، اختلاف قیمت آن هتل را به .طور کامل به میهمان پرداخت
        می کند.

        در این تضمین نامه برای راحتی میهمانان، سعی شده است این مراحل انحام کار کاملا ساده و سریع انجام شود و از نامه
        نگاری و
        فرآیندهای اداری طولانی مدت، دوری شود.
      </p>
    
      <h4 class="font-bold mt-5 title-content">
        ایران هتل چگونه می تواند بهترین قیمت هتل ها را به مشتریان و اعضاء خود ارائه کند؟

      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        ایران هتل بزرگترین وب سایت رزرواسیون آنلاین هتل های ایران است. بنابراین با توجه به دلایل زیر ما توانائی ارائه
        بهترین
        قیمت را برای هتل های ایران داریم:

      </p>
      <ul class="text-muted text-[14px] !font-extralight leading-8 my-3">
        <li> <i class="ico-Check text-green-300 text-lg"></i> با توجه به میزان بالای رزرو سالیانه برای هتل ها و بستن
          بهترین قراردادها با هتل ها </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i> گارانتی برخی هتل ها در برخی از ایام سال</li>
        <li> <i class="ico-Check text-green-300 text-lg"></i> کمترین دریافت کارمزد از هر رزرو</li>
        <li> <i class="ico-Check text-green-300 text-lg"></i> بروز رسانی روزانه نرخ هتل های ایران در صورت کاهش</li>
      </ul>
      <h4 class="font-bold mt-5 title-content">
        تقاضای استفاده از تضمین بهترین قیمت در چه شرایطی پذیرفته می‌شود؟

      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        تقاضای استفاده از تضمین بهترین قیمت در چه شرایطی پذیرفته می‌شود؟
        هر میهمان بعد از انجام رزرو هتلی که برچسب بهترین نرخ را دارد و تنها تا 1 ساعت بعد از رزرو (این زمان محدود به علت
        تغییرات
        لحظه ای و تغییر سیاست های فروش میباشد) ، و در صورت مواجهه با قیمتی پایین‌تر، می‌تواند درخواست استفاده از گارانتی
        بهترین
        قیمت را ارائه داده و مابه التفاوت هزینه پرداخت شده را دریافت نماید. برای اینکه این درخواست میهمان قابل پذیرش
        باشد، هتل
        ارائه شده در سایت ایران هتل و سایر سایت های رزرو باید دارای شرایط یکسان و برابر به شرح زیر باشند:
      </p>
      <ul class="text-muted text-[14px] !font-extralight leading-8 my-3">
        <li> <i class="ico-Check text-green-300 text-lg"></i> پکیج ارائه شده برای فروش ( اقامت صبحانه، فول برد و ... )
          در سایت ایران هتل با سایت مورد نظر یکسان باشد.
        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i> تاریخ ورود میهمان با تاریخ خروج میهمان می بایست یکسان
          باشند (حتی یک روز هم نباید تفاوت داشته باشد.)
        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>نوع واحد رزرو شده برابر و یکسان باشند.
        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>محدودیتی برای طبقه و سمت اتاق وجود نداشته باشد ( برخی آژانس
          ها یک طبقه خاص هتل را می فروشند و به دلایلی این امکان وجود
          دارد ، به علت تفاوت کیفیت آن طبقه با سایر طبقات قیمت متفاوت ) باشد.</li>
        <li> <i class="ico-Check text-green-300 text-lg"></i> پکیج ارائه شده برای فروش ( اقامت صبحانه، فول برد و ... )
          در سایت
          وب سایت مورد نظر دارای مجوزهای لازم و یا نماد اعتماد الکترونیکی باشد.

        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>
          هتل مورد نظر آن وب سایت را به عنوان یک مرکز رزرو مستقیم قبول نماید.


        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>
          جهت رزرو، واحدی برای ارائه داشته باشد ( در برخی موارد واحدها گارانتی می باشند و سایر مراکز توانایی فروش را
          ندارند.)


        </li>
      </ul>
      <h4 class="font-bold mt-5 title-content">
        تقاضای استفاده از تضمین بهترین قیمت در چه شرایطی پذیرفته می‌شود؟

      </h4>
      <ul class="text-muted text-[14px] !font-extralight leading-8 my-3">
        <li> <i class="ico-Check text-green-300 text-lg"></i>
          درخواست گارانتی بهترین نرخ حداکثر تا 48 ساعت کاری بررسی و هماهنگی لازم با میهمان انجام می شود.

        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>پس از ثبت درخواست میهمان، قیمت هتل مورد نظر از سایت مربوط توسط بخش فروش ایران هتل استعلام می شود و داشتن آن واحد برای
        تاریخ مورد نظر چک می شود.

        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i> در صورت مشاهده تخلف و یا تلاش برای سوء استفاده از طرح گارانتی بهترین نرخ حق عدم پذیرش آن درخواست برای ایران هتل محفوظ
        است.

        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>ما به تفاوت در صورت تایید به صورت نقدی یا آی هوبن در اختیار میهمان قرار می گیرد.
        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>ایران هتل می تواند با توجه به شرایط زمانی، شرایط گارانتی بهترین نرخ را برای هر هتلی تغییر دهد.
        </li>
        <li> <i class="ico-Check text-green-300 text-lg"></i>در صورتی که در مورد این بخش سوال یا پیشنهادی دارید با شماره 91005105-021 در روزهای اداری و بین ساعات ( 9 الی 17 ) با ما
        تماس حاصل نمایید. مشتاق شنیدن نظرات شما هستیم
        </li>
      </ul>
      <h4 class="font-bold mt-5 title-content">
        چگونه میتوان برای استفاده از برچسب " گارانتی بهترین نرخ " درخواست داد؟

      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        بعد از مشاهده نرخ کمتر با توجه به شرایط اعلام شده، بلافاصله با بخش فروش ما با شماره 91005105-021 تماس حاصل نموده و با
        ارائه کد رزرو خود همکاران ما را در جریان بگذارید.

      </p>
    
    </div>
  </div>

</div>